import { useId } from "react";
import { CalcIcon } from "./CalcIcon";
import "./calculadora.css";
import "./orcamentos.css";

export const moedaOrcamento = valor => new Intl.NumberFormat("pt-BR", { style:"currency", currency:"BRL" }).format(Number(valor) || 0);
export const percentualOrcamento = valor => new Intl.NumberFormat("pt-BR", { maximumFractionDigits:1 }).format(Number(valor) || 0) + "%";

export function OrcamentoBotao({ children, outline, small, danger, color, className = "", ...props }) {
  return <button type="button" className={`calc-button ${outline ? "calc-button-outline" : "calc-button-primary"}${small ? " budget-button-small" : ""}${danger ? " budget-button-danger" : ""} ${className}`} {...props}>{children}</button>;
}

export function OrcamentoCampo({ label, id, className = "", ...props }) {
  const autoId = useId();
  return <div className="budget-field"><label htmlFor={id || autoId}>{label}</label><input id={id || autoId} className={`calc-input ${className}`} {...props} /></div>;
}

export function OrcamentoCabecalho({ titulo, descricao, onVoltar, voltarLabel = "Voltar aos orçamentos", acao }) {
  return <header className={`calc-page-heading budget-page-heading${onVoltar ? " budget-back-heading" : ""}`}>
    <div className="budget-heading-title">{onVoltar && <button type="button" className="budget-icon-button" onClick={onVoltar} aria-label={voltarLabel}><CalcIcon name="back" size={21} /></button>}
      <div><h1>{titulo}</h1>{descricao && <p>{descricao}</p>}</div>
    </div>{acao}
  </header>;
}

export function OrcamentoVazio({ icone = "receipt", titulo, children }) {
  return <div className="budget-empty"><span className="budget-empty-icon"><CalcIcon name={icone} size={26} /></span><h3>{titulo}</h3>{children && <p>{children}</p>}</div>;
}

export function OrcamentoBusca({ label, ...props }) {
  return <label className="budget-search"><CalcIcon name="search" /><span className="budget-sr-only">{label}</span><input className="calc-input" type="search" {...props} /></label>;
}

export function OrcamentoFinanceiro({ total = 0, custo = 0, lucro = total - custo, margem = total > 0 ? lucro / total * 100 : 0, titulo = "Total do orçamento", children }) {
  return <aside className="budget-panel budget-financial" aria-label="Resumo financeiro">
    <div className="budget-price"><span>{titulo}</span><strong aria-live="polite">{moedaOrcamento(total)}</strong></div>
    <dl className="budget-metrics"><div><dt>Custo de produção</dt><dd>{moedaOrcamento(custo)}</dd></div><div><dt>Lucro estimado</dt><dd className={lucro < 0 ? "budget-loss" : "budget-profit"}>{moedaOrcamento(lucro)}</dd><small>Margem de {percentualOrcamento(margem)}</small></div></dl>
    {children && <div className="budget-financial-content">{children}</div>}
  </aside>;
}
